import {
  ApiPublicConfig,
  ApiPublicConfigError,
  PublicConfigParams,
} from "@services/types/identity/identityTypes";

const getErrorMessage = (response: Response, publicConfig: ApiPublicConfigError) => {
  if (response?.status !== 200) {
    return publicConfig?.non_field_errors?.[0];
  }

  return "";
};

export const loadPublicConfig = async ({
  identityUrl,
  environment,
  onSuccess,
  onError,
}: PublicConfigParams) => {
  try {
    const serviceCode = "darwin-front";
    const [originalTenantCode] = window?.location?.hostname?.split(".") ?? [];

    // Create the request URL with query parameters
    const servicePath = "/api/v1/services/public-config/";
    const apiPath = `${identityUrl}${servicePath}`;

    const makeRequest = async (tenantCode: string) => {
      const params = `?tenant_code=${tenantCode}&service_code=${serviceCode}&environment=${environment}`;
      const request = new Request(`${apiPath}${params}`, {
        method: "GET",
      });

      const response = await fetch(request);
      const publicConfig: ApiPublicConfig = await response.json();

      return { response, publicConfig };
    };

    // First attempt with original tenant code
    let { response, publicConfig } = await makeRequest(originalTenantCode);

    // If 400 error and tenant code ends with "-{environment}", retry with modified tenant code
    if (response?.status === 400 && originalTenantCode?.endsWith("-" + environment)) {
      const modifiedTenantCode = originalTenantCode.replace(new RegExp(`-${environment}$`), "");
      const retryResult = await makeRequest(modifiedTenantCode);

      response = retryResult.response;
      publicConfig = retryResult.publicConfig;
    }

    if (response?.status === 200) {
      onSuccess?.(publicConfig);
    } else {
      const errorMessage = getErrorMessage(
        response,
        (publicConfig as unknown) as ApiPublicConfigError,
      );

      onError?.(response, errorMessage);
    }

    return publicConfig;
  } catch (error) {
    onError?.(error);
  }
};
